import type {
    IdentityDialogContext,
    IdentityDialogStrategy,
} from '@treasury/domain-components/identity-verification-dialog';
import { ChallengeType, SecurityMessage } from '@treasury/domain/channel/mappings/security';
import { OmegaOob } from './omega-oob';
import { OmegaOobOtp } from './omega-oob-otp';
import { OmegaSecureToken } from './omega-secure-token';

export function createDialogStrategy(
    context: IdentityDialogContext,
    challengeMethodType: SecurityMessage['challengeMethodTypeId']
): IdentityDialogStrategy {
    switch (challengeMethodType) {
        case ChallengeType.OutOfBand:
            return new OmegaOob(context);
        case ChallengeType.OutOfBandOTP:
            return new OmegaOobOtp(context);
        case ChallengeType.SecureToken:
            return new OmegaSecureToken(context);
        case 0:
            throw new Error(
                'Cannot create identity dialog strategy. Challenge code zero provided. Did you forget to normalize in client code?'
            );
        default:
            throw new Error(
                `Cannot create identity dialog strategy. Invalid challenge code ${challengeMethodType} provided.`
            );
    }
}
